
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'reference',
  title: 'Mock server',
  section: 'Mock server',
  description: 'Mock bank server',
  parentTocLevel: 4,
  childTocLevel: 5,
  secondLevelToc: true,
  alwaysExpand: true
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Plaid Core Exchange Mock Server' subtitle={metadata.description} mdxType="Header" />
    <p>{`Use our mock bank server to understand the subset of FDX information that Plaid consumes.
This mock server uses hardcoded public bearer tokens.
Remember that in production, bearer tokens must be secure.`}</p>
    <p>{`See the following Postman collection:`}</p>
    <p><a parentName="p" {...{
        "href": "https://god.gw.postman.com/run-collection/20285790-77110c23-da75-448b-8bf2-2c09bf560d6d?action=collection%2Ffork&collection-url=entityId%3D20285790-77110c23-da75-448b-8bf2-2c09bf560d6d%26entityType%3Dcollection%26workspaceId%3Dfbafb5a2-25a1-482a-a65b-1f637a19ed49"
      }}><img parentName="a" {...{
          "src": "https://run.pstmn.io/button.svg",
          "alt": "Run in Postman"
        }}></img></a></p>
    <p>{`Or, skip Postman and make a few example cURL calls directly to the mock server in a command line:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Action`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Example call`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/core-exchange/docs/reference/6.4#accounts"
            }}>{`List all accounts`}</a>{` for the test user`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`curl --request GET 'https://api.firstplaidypusbank.plaid.com/fdx/v6/accounts' --header 'Authorization: Bearer 000000000001'`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/core-exchange/docs/reference/6.4#accountsaccountid"
            }}>{`Get the balance`}</a>{` of the test user's checking account`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`curl --request GET 'https://api.firstplaidypusbank.plaid.com/fdx/v6/accounts/deposit_01_checking' --header 'Authorization: Bearer 000000000001'`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/core-exchange/docs/reference/6.4#accountsaccountidtransactions"
            }}>{`List the transactions`}</a>{` on the test user's checking account`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`curl --request GET 'https://api.firstplaidypusbank.plaid.com/fdx/v6/accounts/deposit_01_checking/transactions?startTime=2022-01-30&endTime=2022-05-30' --header 'Authorization: Bearer 000000000001'`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/core-exchange/docs/reference/6.4#accountsaccountidpayment-networks"
            }}>{`List the supported payment networks`}</a>{` for the test user's savings account`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`curl --request GET 'https://api.firstplaidypusbank.plaid.com/fdx/v6/accounts/deposit_02_savings/payment-networks' --header 'Authorization: Bearer 000000000001'`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/core-exchange/docs/reference/6.4#accountsaccountidcontact"
            }}>{`Get the contact info`}</a>{` on the test user's savings account`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`curl --request GET 'https://api.firstplaidypusbank.plaid.com/fdx/v6/accounts/deposit_02_savings/contact' --header 'Authorization: Bearer 000000000001'`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/core-exchange/docs/reference/6.4#accountsaccountid"
            }}>{`Get the balance`}</a>{` of the test user's mortgage account`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`curl --request GET 'https://api.firstplaidypusbank.plaid.com/fdx/v6/accounts/loan_02_mortgage' --header 'Authorization: Bearer 000000000001'`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/core-exchange/docs/reference/6.4#accountsaccountid"
            }}>{`Get the balance`}</a>{` of the test user's credit card`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`curl --request GET 'https://api.firstplaidypusbank.plaid.com/fdx/v6/accounts/loc_01_creditcard' --header 'Authorization: Bearer 000000000001'`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/core-exchange/docs/reference/6.4#accountsaccountidtransactions"
            }}>{`List the transactions`}</a>{` on the test user's credit card`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`curl --request GET 'https://api.firstplaidypusbank.plaid.com/fdx/v6/accounts/loc_01_creditcard/transactions?startTime=2022-01-30&endTime=2022-05-30' --header 'Authorization: Bearer 000000000001'`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/core-exchange/docs/reference/6.4#accountsaccountidstatements"
            }}>{`List available account statements`}</a>{` for the test user's checking account`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`curl --request GET https://api.firstplaidypusbank.plaid.com/fdx/v6/accounts/deposit_01_checking/statements --header 'Authorization: Bearer 000000000001'`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/core-exchange/docs/reference/6.4#accountsaccountidstatementsstatementid"
            }}>{`Get a single account statement PDF`}</a>{` from the test user's checking account`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`curl --request GET https://api.firstplaidypusbank.plaid.com/fdx/v6/accounts/deposit_01_checking/statements/000001 --header 'Authorization: Bearer 000000000001'`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
